<div class="d-lg-block d-none">
  <fgb-page-header
    [pageTitle]="'games.page.title'"
    [backButtonLink]="'/'"
    [kidsBanner]="'banners/kids-games.jpg'"
  ></fgb-page-header>
</div>
<div class="d-lg-none">
  <ng-container *inPopulation="[population.Kids]">
    <fgb-page-header
      [pageTitle]="'games.page.title'"
      [backButtonLink]="'/'"
      [kidsBanner]="'banners/kids-games.jpg'"
    ></fgb-page-header>
  </ng-container>
  <ng-container *notInPopulation="[population.Kids]">
    <fgb-page-header [pageTitle]="'games.page.title'" [backButtonLink]="'/'" [showBanner]="false"></fgb-page-header>
  </ng-container>
</div>

<div class="container">
  <div class="game-container-sections">
    <ng-container *notInPopulation="[population.Kids]">
      <div class="cursor-pointer" [routerLink]="'/games/predictor'">
        <img [src]="'games/predictor-sponsor.jpeg' | contentAssetImage" />
        <div class="card">
          <div class="">
            <h5>{{ 'games.page.predictor' | translate }}</h5>
            <div class="font-size-14 text-white">{{ 'games.page.predictor.description' | translate }}</div>
          </div>
          <div>
            <div class="btn btn-quaternary">{{ 'games.page.predictor.play' | translate }}</div>
          </div>
        </div>
      </div>
      <ng-container [ngTemplateOutlet]="polls"></ng-container>
    </ng-container>

    <ng-container *inPopulation="[population.Kids]">
      <ng-container [ngTemplateOutlet]="trivia"></ng-container>
    </ng-container>

    <ng-container *inPopulation="[population.Kids]">
      <ng-container [ngTemplateOutlet]="polls"></ng-container>
    </ng-container>
  </div>

  <div class="game-container-sections mt-4">
    <ng-container *notInPopulation="[population.Kids]">
      <ng-container [ngTemplateOutlet]="trivia"></ng-container>
    </ng-container>
    <ng-container *notInPopulation="[population.Kids]">
      <div *fgbWebsiteContentFeatureFlag="'feature.flag.pickaplayer'" class="cursor-pointer" [routerLink]="'/games/pickaplayer'">
        <img [src]="'games/pickaplayer-thumbnail.jpg' | contentAssetImage" />
        <div class="card">
          <div class="">
            <h5>{{ 'games.page.pickaplayer' | translate }}</h5>
            <div class="font-size-14 text-white">{{ 'games.page.pickaplayer.description' | translate }}</div>
          </div>
          <div>
            <div class="btn btn-quaternary">{{ 'games.page.pickaplayer.play' | translate }}</div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #polls>
  <div class="cursor-pointer" [routerLink]="'/games/polls'">
    <ng-container *notInPopulation="[population.Kids]">
      <img [src]="'games/polls-thumnail.jpg' | contentAssetImage" />
    </ng-container>
    <ng-container *inPopulation="[population.Kids]">
      <img class="kids-polls-img" [src]="'games/kids-polls.jpg' | contentAssetImage" />
    </ng-container>
    <div class="card">
      <div class="">
        <h5>{{ 'games.page.polls' | translate }}</h5>
        <div class="font-size-14 text-white">{{ 'games.page.polls.description' | translate }}</div>
      </div>
      <div>
        <div class="btn btn-quaternary">{{ 'games.page.polls.play' | translate }}</div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #trivia>
  <div class="cursor-pointer" [routerLink]="'/games/trivia'">
    <img *notInPopulation="[population.Kids]" [src]="'games/trivia-thumnail.png' | contentAssetImage" />
    <img class="kids-trivia-img" *inPopulation="[population.Kids]" [src]="'games/kids-trivia.jpg' | contentAssetImage" />
    <div class="card">
      <div class="">
        <h5>{{ 'games.page.trivia' | translate }}</h5>
        <div class="font-size-14 text-white">{{ 'games.page.trivia.description' | translate }}</div>
      </div>
      <div>
        <div class="btn btn-quaternary">{{ 'games.page.trivia.play' | translate }}</div>
      </div>
    </div>
  </div>
</ng-template>
